import { useMemo } from 'react';
import { Week } from '../../../../../../../../../../../store/planStore';

const usePlanTotals = (weeks: Week[]) => {
  const tableData = weeks.map((week) => week.copy.value);

  const planTotals = useMemo(() => {
    return (
      tableData[0]?.map((_, rowIndex) => {
        let rowSum = 0;
        weeks.forEach((week, weekIndex) => {
          const value = tableData[weekIndex]?.[rowIndex]?.value ?? 0;
          rowSum += value;
        });
        return rowSum;
      }) ?? []
    );
  }, [tableData, weeks]);

  return { planTotals };
};

export default usePlanTotals;
